module.exports = __webpack_public_path__ + "static/media/Group 1320.9abe6cce.svg";